module.exports = __webpack_public_path__ + "857a2ea8cac09a8d53e750964361c13f.jpg";